import { useEffect } from "react";
import Lenis from "lenis";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

/** Inertial wheel scrolling: the page keeps gliding briefly after each wheel step. Desktop pointers only; touch and reduced-motion stay native.
 *  Duration-based ease-out (not lerp): a lerp tail crawls 1px with stalls before it stops, which reads as stutter. */
export function useSmoothScroll(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || !window.matchMedia("(pointer: fine)").matches) return;
    const lenis = new Lenis({ duration: 0.7, easing: (t) => 1 - Math.pow(1 - t, 2), smoothWheel: true, anchors: { offset: -64 } });
    lenis.on("scroll", ScrollTrigger.update);
    const tick = (time: number) => lenis.raf(time * 1000);
    gsap.ticker.add(tick);
    gsap.ticker.lagSmoothing(0);
    return () => { gsap.ticker.remove(tick); lenis.destroy(); };
  }, [enabled]);
}
